<template>
  <v-app-bar
    class="main-header"
    height="64"
    fixed
    color="primary"
    elevation="0"
  >
    <v-btn icon class="mx-1" @click.stop="TOGGLE_DRAWER">
      <template v-if="DRAWER_STATE">
        <v-icon style="font-size: 28px">mdi-arrow-left</v-icon>
      </template>
      <template v-else>
        <v-icon style="font-size: 28px">mdi-menu</v-icon>
      </template>
    </v-btn>
    <v-toolbar-title>{{ this.$store.state.titleApp }}</v-toolbar-title>
    <v-spacer></v-spacer>
      <Search />
    <v-btn v-if="hasFeatureProgram" icon class="mr-2" to="/program-information">
      <v-badge v-if="programInfo > 0" color="error" overlap dot>
        <v-icon style="font-size: 28px" color="black">mdi-bell</v-icon>
      </v-badge>
      <v-icon style="font-size: 28px" color="black" v-else>mdi-bell</v-icon>
    </v-btn>
    <v-btn class="mr-2" style="box-shadow: none;" to="/notifications">
      <v-badge v-if="notifCounter > 0" color="error" :content="notifCounter" overlap>
        <v-icon style="font-size: 28px" color="black">mdi-bell-outline</v-icon>
      </v-badge>
      <v-icon v-else style="font-size: 28px" color="black">mdi-bell-outline</v-icon>
    </v-btn>
    <v-btn icon class="mr-2" to="/cart/nonreward">
      <v-badge
        v-if="cartItemCounter > 0"
        color="error"
        :content="cartItemCounter"
        overlap
      >
        <v-icon style="font-size: 28px" color="black">mdi-cart</v-icon>
      </v-badge>
      <v-icon style="font-size: 28px" color="black" v-else>mdi-cart</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
import { mapActions, mapState } from "vuex";
import config from "../../config";
// import Search from "@/components/Search/Search";

export default {
  name: "Header",
  // components: { Search },
  data: () => ({
    // dialog: false,
    config,
    searchCollapse: true,
    notifications: [
      {
        text: "Check out this awesome ticket",
        icon: "mdi-tag",
        color: "warning",
      },
      {
        text: "What is the best way to get ...",
        icon: "mdi-thumb-up",
        color: "success",
      },
      {
        text: "This is just a simple notification",
        icon: "mdi-flag",
        color: "error",
      },
      {
        text: "12 new orders has arrived today",
        icon: "mdi-cart",
        color: "primary",
      },
    ],
    messages: [
      {
        text: "JH",
        name: "Jane Hew",
        message: "Hey! How is it going?",
        time: "09:32",
        color: "warning",
      },
      {
        text: "LB",
        name: "Lloyd Brown",
        message: "Check out my new Dashboard",
        time: "10:02",
        color: "success",
      },
      {
        text: "MW",
        name: "Mark Winstein",
        message: "I want rearrange the appointment",
        time: "12:16",
        color: "error",
      },
      {
        text: "LD",
        name: "Liana Dutti",
        message: "Good news from sale department",
        time: "14:56",
        color: "primary",
      },
    ],
    account: [
      {
        text: "Aktivasi VA",
        icon: "mdi-account",
        color: "textColor",
        link: "/registrasiVA",
      },
      {
        text: "Ubah PIN",
        icon: "mdi-key-variant",
        color: "textColor",
        link: "/changePIN",
      },
      {
        text: "Reset PIN",
        icon: "mdi-key-variant",
        color: "textColor",
        link: "/resetPIN",
      },
      {
        text: "Ubah Kata Sandi",
        icon: "mdi-key",
        color: "textColor",
        link: "/changePass",
      },
      {
        text: "Profil",
        icon: "mdi-account",
        color: "textColor",
        link: "/profile",
      },
    ],
    notificationsBadge: true,
    messageBadge: true,
  }),
  computed: {
    ...mapState(["drawer", "programNotif", 'countNotifUnread','distType']),
    DRAWER_STATE: {
      get() {
        return this.drawer;
      },
    },
    cartList: function() {
      // console.log('isi  cartlist', this.$store.state.cartList)
      return this.$store.state.cartList;
    },
    cartListReward: function() {
      // console.log('isi  cartlist', this.$store.state.cartList)
      return this.$store.state.cartListReward;
    },
    cartItemCounter: function() {
      return Object.keys(this.cartList.new).length + Object.keys(this.cartListReward).length;
    },
    notifCounter(){
      //TO DO
      return this.countNotifUnread;
    },
    programInfo: function() {
      return Object.keys(this.programNotif).length;
    },
    // hasFeatureProgram() {
    //   return (
    //     this.$store.state.titleApp === "Beranda" &&
    //     this.hasFeature("VIEW_PROGRAM")
    //   );
    // },
  },
  // watch: {
  //   cart () {
  //     console.log('im executed')
  //     this.cart()
  //   }
  // },
  methods: {
    ...mapActions(["getCartList", "programNotification",'countNotificationUnread']),
    loadCartList() {
      this.getCartList({
        by: {
          pageNumber: 1,
          pageSize: 100,
          searchVal: "",
          status: "CIS_NEW",
        },
        isGroupedByStatus: true,
      })
        .then((response) => {
          this.$helpers.handleSuccess(response);
        })
        .catch((error) => {
          this.$helpers.handleError(error);
        });
    },
    loadNotificationProgram() {
      this.programNotification({
        pageNumber: 0,
        pageSize: 100,
      })
        .then((response) => {
          this.$helpers.handleSuccess(response);
        })
        .catch((error) => {
          this.$helpers.handleError(error);
        });
    },
    loadCountNotifUnread(){
      this.countNotificationUnread()
      .then((response) => {
          this.$helpers.handleSuccess(response);
        })
        .catch((error) => {
          this.$helpers.handleError(error);
        });
    },
    ...mapActions(["TOGGLE_DRAWER"]),
    // logOut: function () {
    //   // window.localStorage.setItem('authenticated', false);
    //   // this.$router.push('/login');
    //   this.$store.dispatch("logout").then((response) => {
    //     if (response) {
    //       let data = response.data;
    //       if (data.status == 0){
    //         const snackbarMsg = data.message
    //         const snackbarColor = 'red'
    //         this.$store.commit('setShowSnackbar', { snackbarMsg, snackbarColor })
    //       }else {
    //         const snackbarMsg = data.message
    //         const snackbarColor = 'green'
    //         this.$store.commit('setShowSnackbar', { snackbarMsg, snackbarColor })
    //         this.$router.push({ name: 'home' })
    //       }
    //     }
    //   }).catch(error => {
    //     if (error.response) {
    //       let response = error.response;
    //       // let data = response.data;
    //       let hasToken = !!response.config.headers.Authorization;
    //       // console.log(response)
    //       switch(response.status){
    //         case 403 : if (hasToken){
    //             this.$store.commit('logout')
    //             this.$router.push({ name: 'home' })
    //           }
    //         }
    //       }
    //         // console.log(err.response);
    //         // let hasToken = !!err.response.config.headers.Authorization;
    //         // switch(err.response.status){
    //         //   case 403 : if (hasToken){
    //         //     this.$store.commit('logout')
    //         //     return this.$router.push('/')
    //         //   }
    //         // }
    //   });
    // },
  },
  mounted() {
    this.loadCartList();
    // this.loadNotificationProgram();
    this.loadCountNotifUnread();

    // CEK DISTRIBUTOR UNTUK GANTI WARNA PRIMARY
    if (this.distType == this.$constant.DIST_SMA) {
      this.$vuetify.theme.themes.light.primary = '#FAAC1B'; // kuning
    }else{
      this.$vuetify.theme.themes.light.primary = '#FCB3C5'; // kuning
    }
  },
};
</script>

<style src="./Header.scss" lang="scss"></style>
